module.exports = __webpack_public_path__ + "img/cta-flip.02e5eea2.jpg";